const t={light:"#1D7AFC",dark:"#1D7AFC"};export{t as PEOPLE_CARD_ACCENT_COLOR};
